"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.throttle = exports.compareDate = exports.removeResize = exports.addResize = exports.isNotEqualByObject = exports.getRowDataByTimeList = exports.getStringTimeByData = exports.addZero = exports.toInt = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 转化为数字
var toInt = function toInt(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseInt(value, 10) || defaultValue;
};

exports.toInt = toInt;

var addZero = function addZero() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tempValue = toInt(value);

  if (tempValue < 10) {
    tempValue = '0' + tempValue;
  } else {
    tempValue = tempValue + '';
  }

  if (typeof value === 'string' && value.length < 1) {
    tempValue = '';
  }

  return tempValue;
}; // 获取字符串的时间


exports.addZero = addZero;

var getStringTimeByData = function getStringTimeByData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = [];

  if (!(0, _spauiUtils.isUndefined)(data.hour)) {
    result.push(addZero(data.hour));

    if (!(0, _spauiUtils.isUndefined)(data.minute)) {
      result.push(addZero(data.minute));
    }

    if (!(0, _spauiUtils.isUndefined)(data.second)) {
      result.push(addZero(data.second));
    }
  }

  return result.join(':');
}; // 从时分秒列表中获取原始数据
// 如果有timeList，初始化时会用第一个做数据转化，所以这里替换成原来的item数据


exports.getStringTimeByData = getStringTimeByData;

var getRowDataByTimeList = function getRowDataByTimeList() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var result = value;

  if ((0, _spauiUtils.isArray)(timeList) && timeList.length > 0) {
    timeList.map(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var temp = item.split(':'),
          i = 0;

      for (; i < 3; i++) {
        temp[i] = temp[i] || '00';
      }

      if (temp.join(':') === value) {
        result = item;
      }

      return item;
    });
  }

  return result;
}; // 判断两个对象是否相等


exports.getRowDataByTimeList = getRowDataByTimeList;

var isNotEqualByObject = function isNotEqualByObject(fromObject, toObject) {
  var result = false;

  if ((typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) === 'object' && JSON.stringify && _typeof(fromObject) === 'object' && _typeof(toObject) === 'object' && JSON.stringify(fromObject) !== JSON.stringify(toObject) || typeof toObject === 'undefined') {
    result = true;
  }

  return result;
};

exports.isNotEqualByObject = isNotEqualByObject;
var haveJQuery = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.jQuery === 'function'; // 添加resize

var addResize = function addResize(resizeCallback) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (target) {
    if (haveJQuery) {
      jQuery(target).on('resize', resizeCallback);
    } else if (_typeof(target) === 'object' && (0, _spauiUtils.isFunction)(target.addEventListener)) {
      target.addEventListener('resize', resizeCallback);
    }
  }
}; // 去除resize


exports.addResize = addResize;

var removeResize = function removeResize(resizeCallback) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (target) {
    if (haveJQuery) {
      jQuery(target).off('resize', resizeCallback);
    } else if (_typeof(target) === 'object' && (0, _spauiUtils.isFunction)(target.removeEventListener)) {
      target.removeEventListener('resize', resizeCallback);
    }
  }
}; // 比较日期，dateA > dateB 返回正数； dateA = dateB 返回0; dateA < dateB 返回负数；


exports.removeResize = removeResize;

var compareDate = function compareDate() {
  var dateA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dateB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _dateA$year = dateA.year,
      dateAYear = _dateA$year === void 0 ? 0 : _dateA$year,
      _dateA$month = dateA.month,
      dateAMonth = _dateA$month === void 0 ? 0 : _dateA$month,
      _dateA$date = dateA.date,
      dateADate = _dateA$date === void 0 ? 1 : _dateA$date;
  var _dateB$year = dateB.year,
      dateBYear = _dateB$year === void 0 ? 0 : _dateB$year,
      _dateB$month = dateB.month,
      dateBMonth = _dateB$month === void 0 ? 0 : _dateB$month,
      _dateB$date = dateB.date,
      dateBDate = _dateB$date === void 0 ? 1 : _dateB$date;
  var result = 0,
      dateATime = 0,
      dateBTime = 0;

  if (dateAYear > 0 && dateBYear > 0) {
    dateATime = new Date(dateAYear, dateAMonth, dateADate).getTime();
    dateBTime = new Date(dateBYear, dateBMonth, dateBDate).getTime();
    result = dateATime - dateBTime;
  }

  return result;
};
/**
 * 函数节流
 * @param {function} fn 需要节流的函数
 * @param {number} [delay=100] 延迟的时间
 */


exports.compareDate = compareDate;

var throttle = function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timer = null;
  var timeStart;
  return function () {
    var context = this;
    var args = arguments;
    var timeCurrent = +new Date();
    clearTimeout(timer);

    if (!timeStart) {
      timeStart = timeCurrent;
    }

    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

exports.throttle = throttle;
var _default = {
  addZero: addZero,
  toInt: toInt,
  getStringTimeByData: getStringTimeByData,
  getRowDataByTimeList: getRowDataByTimeList,
  isNotEqualByObject: isNotEqualByObject,
  compareDate: compareDate,
  addResize: addResize,
  removeResize: removeResize,
  throttle: throttle
};
exports["default"] = _default;